import { useCallback, useEffect, useReducer } from 'react'

/**
 * Increments the state which causes a rerender and executes a callback
 * @param {function} callback - callback to execute after state update
 * @returns {function}
 */
export const useForceUpdate = (callback?) => {
  const [state, updater] = useReducer((x) => x + 1, 0)

  useEffect(() => {
    callback && callback()
  }, [state])

  return useCallback(() => {
    updater()
  }, [])
}
